import { useCallback, useEffect, useState, useRef } from 'react';
import { Spinner } from '../../../shared/spinner';
import styled from 'styled-components';
import { notification } from 'antd';

// services
import * as DashboardService from '../../../../services/bb-api/dashboards';

type Props = { country?: number  }

export const OverviewTable: React.FC<Props> = ({ country }) => {
	const [totalData, setTotalData] = useState<Record<string, any>>({});
	const [periodData, setPeriodData] = useState<Record<string, any>>({});

	const getData = useCallback(() => {
		try {
			DashboardService.queryTotalCounts(country).then(setTotalData);
			DashboardService.queryPeriodCounts(country).then(setPeriodData);
		} catch (error) {
			const message = 'Der skete en fejl';
			notification.error({ message });
		}
	}, [])

	useEffect(() => {
		getData();
		const intervalTime = 20 * 1000 // 20 seconds
		const intervalId = setInterval(getData, intervalTime)
		return () => clearInterval(intervalId)
	}, [getData]);

	const audioRef = useRef<HTMLAudioElement>(null);

	useEffect(() => {
		const audio = audioRef.current;
		if (audio === null) return;
		audio.pause();
	}, []);

	useEffect(() => {
		if (country !== 3) return
		if (totalData.usersCount === 0 || totalData.usersCount === undefined) return;

		const audio = audioRef.current;
		if (audio === null) return;

		audio.play();
	}, [totalData.usersCount]);

	return (
		<Container className="overview-table">
			<audio autoPlay ref={audioRef}>
				<source src="/assets/berlin.mp3" type="audio/mpeg" />
			</audio>
			<table>
				<thead className="total-header">
					<tr>
						<th>Brugere</th>
						<th>Beskeder</th>
						<th>Bobler</th>
						<th>Samtaler</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td className="cell-border">
							{Number(totalData?.usersCount).toLocaleString('da-DK') ?? <Spinner />}
						</td>
						<td className="cell-border">
							{Number(totalData?.messagesCount).toLocaleString('da-DK') ?? <Spinner />}
						</td>
						<td className="cell-border">
							{Number(totalData?.postsCount).toLocaleString('da-DK') ?? <Spinner />}
						</td>
						<td>{Number(totalData?.conversationsCount).toLocaleString('da-DK') ?? <Spinner />}</td>
					</tr>
				</tbody>
				<thead>
					<tr>
						<th colSpan={4}>Sidste 24 timer</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td className="cell-border">
							{Number(periodData?.usersCount).toLocaleString('da-DK') ?? <Spinner />}
						</td>
						<td className="cell-border">
							{Number(periodData?.messagesCount).toLocaleString('da-DK') ?? <Spinner />}
						</td>
						<td className="cell-border">
							{Number(periodData?.postsCount).toLocaleString('da-DK') ?? <Spinner />}
						</td>
						<td>{Number(periodData?.conversationsCount).toLocaleString('da-DK') ?? <Spinner />}</td>
					</tr>
				</tbody>
			</table>
		</Container>
	);
}

const Container = styled.div`
	table {
		width: 100%;
		text-align: center;
		table-layout: fixed;

		tr td {
			font-size: calc(3em + 1vw);
			background-color: #1f2937;
			color: #ffffff;
		}

		.total-header th {
			font-size: calc(1.3em + 1vw);
			color: #9ca3af;
		}

		thead th {
			font-size: calc(0.7em + 1vw);
			color: #9ca3af;
		}

		.cell-border {
			border-right: 2px solid #9ca3af;
		}
	}
`;
